import React from 'react';

import { type NavMenuItem } from 'types';

import { Link } from 'components/Link/Link';

import styles from './MobileNavigation.module.scss';

interface Props {
  menuItems: NavMenuItem[];
}

export const MobileNavigation: React.FC<Props> = ({ menuItems }) => {
  return (
    <nav data-testid="mobile-navigation-container" className={styles.mobileNavbar}>
      {menuItems.map(({ url, label, isActive, icon }: NavMenuItem) => {
        return (
          <Link
            key={label}
            href={url}
            className={`${styles.mobileButton} ${isActive ? styles.activeMobileButton : null}`}
          >
            <img src={icon} alt={`${label}-icon`} />
            {label}
          </Link>
        );
      })}
    </nav>
  );
};
